/**
 * 媒体详情
 */
"user strict";
angular.module('manageSysManageMediaNameDetailModule', [])
	.controller('manageSysManageMediaNameDetailCtrl', ['$scope', 'trsHttpService', '$q', '$stateParams', function($scope, trsHttpService, $q, $stateParams) {

		initStatus();
		initData();

		/**
		 * [initStatus 初始化状态函数开始]
		 * @return {[type]} [description]
		 */
		function initStatus() {
			// 分页参数
			$scope.page = {
                CURRPAGE: 1, // 当前页
                PAGESIZE: 20, // 一页显示数据量
                ITEMCOUNT: 0, // 总数据量
                PAGECOUNT: 1, // 总页数
                gotoPage: 1, // 跳转到页数
            };
	        // 时间范围参数
	        $scope.time = {};
	        // 搜索关键词
	        $scope.keyword = '';
	        // 列表数据
	        $scope.items = [];
	        // 请求参数
	        $scope.params = {};
	        $scope.headerTitle = {
	        	name: $stateParams.NAME,
	        	time: $stateParams.BeginDate ? ("（" + $stateParams.BeginDate + ' 至 ' + $stateParams.EndDate + "）") : ''
	        }
		}

		/**
		 * [initData 初始化数据]
		 * @return {[type]} [description]
		 */
		function initData() {
			requestData();
		}

		/**
		 * [requestData 接口--请求媒体详情列表]
		 * @return {[type]} [description]
		 */
		function requestData() {
			var deffer = $q.defer();
			$scope.params = {
				serviceid: "mlf_xinhuashedoccount",
                methodname: 'findMetaViewDatasByIds',
                MetadataIds: localStorage.getItem("MetadataIds") || '',
                KeyWords: $scope.keyword,
                CurrPage: $scope.page.CURRPAGE,
                PageSize: $scope.page.PAGESIZE
			}
			if(JSON.stringify($scope.time) !== '{}') {
				$scope.params.BeginDate = $scope.time.startDate + ' 00:00:00';
				$scope.params.EndDate = $scope.time.endDate + ' 23:59:59';
			}
			$scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "get").then(function(res) {
                res.DATA.map(function(item) {
                    item.docTitle = item.LISTTITLE || item.TITLE
                })
	            $scope.items = res.DATA;
            	$scope.page.ITEMCOUNT = res.PAGER.ITEMCOUNT;
            	$scope.page.PAGECOUNT = res.PAGER.PAGECOUNT;
                deffer.resolve(res);
            });
            return deffer.promise;
		}

		/**
		 * [queryByDropdown 筛选条件触发后请求数据]
		 * @param  {[type]} key   [请求对象参数key]
		 * @param  {[type]} value [请求对象值]
		 */
		$scope.queryByDropdown = function(key, value) {
			$scope.params[key] = value;
            $scope.page.CURRPAGE = 1;
            $scope.page.gotoPage = $scope.page.CURRPAGE;
            requestData();
		}

		/**
         * [fullTextSearch description] 搜索
         * @return {[type]} [description]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                requestData();
            }
        };

		/**
         * [selectPageNum description] 选择一页要显示的数据量
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function() {
            $scope.params.PAGESIZE = $scope.page.PAGESIZE;
            $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [pageChanged description] 下一页 页面改变调取数据
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.page.gotoPage = $scope.page.CURRPAGE;
            $scope.params.PAGESIZE = $scope.page.PAGESIZE;
            $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [jumpToPage description] 跳转页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.page.gotoPage > $scope.page.PAGECOUNT) {
                $scope.page.gotoPage = $scope.page.PAGECOUNT;
            }
            $scope.page.CURRPAGE = $scope.page.gotoPage;
            $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            $scope.params.PAGESIZE = $scope.page.PAGESIZE;
            requestData();
        };

		/**
         * [cancel goBack] 返回
         * @return {[type]} [description]
         */
        $scope.goBack = function() {
            window.history.go(-1);
        };
	}])
